/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type InsightsChartType =
  | ChartType.Bar
  | ChartType.Line
  | ChartType.Column
  | ChartType.Pie
  | ChartType.Table
  | ChartType.Metric
  | ChartType.FunnelSteps
  | ChartType.FunnelTopPaths
  | ChartType.RetentionCurve;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "TimeUnit".
 */
export type TimeUnit = BaseTimeUnit | ExtendedTimeUnit | NonStandardTimeUnit | SpecialTimeUnit;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ShowClause".
 */
export type ShowClause = FormulaShowClause | BehaviorShowClause;
export type MultiAttributionType1 = MultiAttributionType.Custom;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "JsonValue".
 */
export type JsonValue = any;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FiltersDeterminer".
 */
export type FiltersDeterminer = "all" | "any";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionType".
 */
export type RetentionType = "compounded" | "birth" | "addiction";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionUnboundedModeType".
 */
export type RetentionUnboundedModeType = "none" | "carry_back" | "carry_forward" | "consecutive_forward";
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "DataGroupId".
 */
export type DataGroupId = string | null;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MATH_TYPE".
 */
export type MATH_TYPE =
  | PRIMITIVE_MATH_TYPES
  | NUMERIC_MATH_TYPES
  | XAU_MATH_TYPES
  | PER_USER_AGGREGATIONS
  | FUNNELS_MATH_TYPES
  | RETENTION_MATH_TYPES;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortConfig".
 */
export type SortConfig = SortByColumnsConfig | SortByValueConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatSortConfig".
 */
export type FlatSortConfig = FlatLabelSortConfig | FlatValueSortConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatOrColumnSortConfig".
 */
export type FlatOrColumnSortConfig = FlatSortConfig | SortConfig;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FilteredBreakdownSegments".
 */
export type FilteredBreakdownSegments = SavedLegend | SavedLegend[];
/**
 * used for specifying label or color overrides on specific segments
 */
export type LegendOverrides = {
  [k: string]: LegendOverride;
} | null;
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ViewNLimit".
 */
export type ViewNLimit = number | null;

export interface InsightsBookmarkParams {
  columnWidths?: ColumnWidths | null;
  displayOptions: DisplayOptions;
  name?: string | null;
  sections: Sections;
  sorting?: InsightsBookmarkSortConfig | null;
  forecastComparison?: ForecastComparison | null;
  liftComparison?: any;
  timeComparison?: any;
  legend?: InsightsLegend | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ColumnWidths".
 */
export interface ColumnWidths {
  bar: {
    [k: string]: any;
  };
  [k: string]: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "DisplayOptions".
 */
export interface DisplayOptions {
  chartType: InsightsChartType;
  plotStyle?: ChartPlotStyle | null;
  analysis?: AnalysisType | null;
  value?: ValueRepresentationType | null;
  rollingWindowSize?: number | null;
  timeUnit?: TimeUnit | null;
  primaryYAxisOptions?: any;
  secondaryYAxisOptions?: any;
  theme?: any;
  xAxisOptions?: any;
  statSigControl?: SegmentId[] | null;
  funnelStepsSelectedTableColumns?: FunnelStepsSelectedTableColumns | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SegmentId".
 */
export interface SegmentId {
  /**
   * raw string value of the segment
   */
  prop: string;
  /**
   * user-friendly renaming of prop, suitable for printing
   */
  propName?: string | null;
  /**
   * Query parameters not encapsulated by the prop which are necessary to recreate
   * this segment.
   *
   * ex: bucketSize and index for a bucketed numeric segment
   */
  cohortDesc?: {
    [k: string]: any;
  };
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelStepsSelectedTableColumns".
 */
export interface FunnelStepsSelectedTableColumns {
  "conv-first-step"?: boolean;
  "conv-prev-step"?: boolean;
  count?: boolean;
  "stat-sig"?: boolean;
  "time-first-step"?: boolean;
  "time-prev-step"?: boolean;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Sections".
 */
export interface Sections {
  show: ShowClause[];
  cohorts?: JsonValue[] | null;
  group_by?: JsonValue[] | null;
  group?: JsonValue[] | null;
  filter?: JsonValue[] | null;
  formula?: JsonValue[] | null;
  time: JsonValue[];
  globalDataGroupId?: string | null;
  metricLevelDataGroups?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FormulaShowClause".
 */
export interface FormulaShowClause {
  _idx?: string;
  type?: TopLevelMetricType.Formula;
  formula?: any;
  measurement?: FormulaMeasurement | null;
  statsig?: Statsig | null;
  display?: MetricDisplay | null;
  isHidden?: boolean | null;
  isExpanded?: boolean | null;
  comparisons?: JsonValue[] | null;
  id?: number | null;
  definition?: string | null;
  name?: string | null;
  referencedMetrics?: BehaviorShowClause[] | null;
  hasUnsavedChanges?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FormulaMeasurement".
 */
export interface FormulaMeasurement {
  cumulative?: boolean | null;
  rolling?: RollingMeasurement | null;
  multiAttribution?: PredefinedMultiAttribution | CustomMultiAttribution | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RollingMeasurement".
 */
export interface RollingMeasurement {
  rollingWindowSize?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PredefinedMultiAttribution".
 */
export interface PredefinedMultiAttribution {
  type: MultiAttributionType;
  name?: string | null;
  weights?: MultiAttributionWeights | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MultiAttributionWeights".
 */
export interface MultiAttributionWeights {
  first: number;
  middle: number;
  last: number;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "CustomMultiAttribution".
 */
export interface CustomMultiAttribution {
  type: MultiAttributionType1;
  name: string;
  weights: MultiAttributionWeights;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Statsig".
 */
export interface Statsig {
  confidence?: number | null;
  control_key: string;
  exposures?: {
    [k: string]: number;
  } | null;
  sequential_testing_adjustment?: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MetricDisplay".
 */
export interface MetricDisplay {
  axis?: AxisAssignment | null;
  prefix?: string | null;
  suffix?: string | null;
  precision?: (0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8) | null;
  abbrev?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BehaviorShowClause".
 */
export interface BehaviorShowClause {
  _idx?: string;
  type?: TopLevelMetricType.Metric;
  id?: number | null;
  userNamed?: boolean | null;
  name?: string | null;
  behavior?: Behavior | null;
  measurement?: BehaviorMeasurement | null;
  statsig?: Statsig | null;
  comparisons?: JsonValue[] | null;
  display?: MetricDisplay | null;
  isHidden?: boolean | null;
  isExpanded?: boolean | null;
  labelPrefix?: string | null;
  formulaLabel?: string | null;
  showClauseIndex?: number | null;
  hasUnsavedChanges?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "Behavior".
 */
export interface Behavior {
  type?: MetricType | null;
  id?: number | null;
  name?: string | null;
  renamed?: string | null;
  dataGroupId?: string | null;
  filters?: JsonValue[] | null;
  filtersDeterminer?: FiltersDeterminer | null;
  resourceType?: InsightsResourceType | null;
  behaviors?: SubBehavior[] | null;
  raw_cohort?: any;
  customBucket?: any;
  conversionWindowDuration?: number | null;
  conversionWindowUnit?: ConversionWindowUnit | null;
  funnelReentryMode?: FunnelReentryModeType | null;
  funnelOrder?: FunnelOrder | null;
  exclusions?: ExclusionFunnelStep[] | null;
  aggregateBy?: JsonValue[] | null;
  retentionType?: RetentionType | null;
  retentionAlignmentType?: RetentionAlignmentType | null;
  retentionUnit?: TimeUnit | null;
  retentionUnbounded?: boolean | null;
  retentionUnboundedMode?: RetentionUnboundedModeType | null;
  retentionCustomBucketSizes?: number[] | null;
  segmentationEvent?: string | null;
  unsavedId?: string | null;
  search?: string | null;
  profileType?: string | null;
  dataset?: string | null;
  datasetId?: string | null;
  projectId?: number | null;
  display?: MetricDisplay | null;
  disableCohortize?: boolean | null;
  customEventSet?: boolean | null;
  hasUnsavedChanges?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SubBehavior".
 */
export interface SubBehavior {
  type?: MetricType.Event | MetricType.CustomEvent | MetricType.Funnel;
  id?: number | null;
  name?: string | null;
  renamed?: string | null;
  filters?: JsonValue[] | null;
  filtersDeterminer?: FiltersDeterminer | null;
  funnelOrder?: FunnelOrder | null;
  behaviors?: SubBehavior[] | null;
  display?: MetricDisplay | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ExclusionFunnelStep".
 */
export interface ExclusionFunnelStep {
  bool_op?: FiltersOperator | null;
  property_filter_params_list?: JsonValue[] | null;
  event?: string | null;
  event_id?: number | null;
  custom_event?: number | null;
  custom_event_name?: string | null;
  step_label?: string | null;
  session_event?: START_END_TYPE | null;
  forward?: number | null;
  reverse?: number | null;
  steps: StepRange;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "StepRange".
 */
export interface StepRange {
  from?: number | null;
  to?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BehaviorMeasurement".
 */
export interface BehaviorMeasurement {
  dataGroupId?: DataGroupId | null;
  math?: MATH_TYPE | null;
  property?: any;
  cumulative?: boolean | null;
  perUserAggregation?: PER_USER_AGGREGATIONS | null;
  rolling?: RollingMeasurement | null;
  segmentMethod?: COUNT_USERS_ONCE_TYPE | null;
  multiAttribution?: PredefinedMultiAttribution | CustomMultiAttribution | null;
  stepIndex?: number | null;
  actionMode?: string | null;
  actionStep?: number | null;
  retentionBucketIndex?: number | null;
  retentionCumulative?: boolean | null;
  retentionSegmentationEvent?: any;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsBookmarkSortConfig".
 */
export interface InsightsBookmarkSortConfig {
  bar?: SortConfig | null;
  table?: SortConfig | OldTableSortByValue | null;
  /**
   * In the bookmark, line chart can either have the old FlatSortConfig or the new SortConfig format
   */
  line?: FlatOrColumnSortConfig | null;
  "insights-metric"?: SortConfig | null;
  pie?: SortConfig | null;
  /**
   * Retention specific
   */
  "retention-curve"?: SortConfig | null;
}
/**
 * sort by segment columns (segment-grouped sort)
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortByColumnsConfig".
 */
export interface SortByColumnsConfig {
  sortBy: SortBy.Column;
  /**
   * value field to specify which value to sort secondarily on
   */
  valueField?: string | null;
  colSortAttrs: FlatSortConfig[];
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatLabelSortConfig".
 */
export interface FlatLabelSortConfig {
  sortBy: SortBy.Label;
  sortOrder: SortOrder;
  valueField?: string | null;
  viewNLimit?: number | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FlatValueSortConfig".
 */
export interface FlatValueSortConfig {
  sortBy: SortBy.Value | SortBy.LiftComparisonValue;
  sortOrder: SortOrder;
  /**
   * valueField required when sorting by value (sortBy.Value) and there is > 1 valueField. Used for data tables.
   */
  valueField?: string | null;
  viewNLimit?: number | null;
}
/**
 * sort by a single value column (flat sort). Still persists colSortAttrs so that if we switch back to sorting by
 * columns, we preserve the prior sorts on the columns
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortByValueConfig".
 */
export interface SortByValueConfig {
  sortBy: SortBy.Value | SortBy.LiftComparisonValue;
  sortOrder?: SortOrder | null;
  /**
   * valueField required when sorting by value (sortBy.Value) and there is > 1 valueField. Used for data tables.
   */
  valueField?: string | null;
  colSortAttrs: FlatSortConfig[];
  viewNLimit?: number | null;
}
/**
 * Same as SortByValueConfig except:
 * 1) sortColumn instead of valueField
 * 2) colSortAttrs can only be FlatLabelSortConfig, not FlatValueSortConfig
 *
 * Must convert this for use with data-table
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "OldTableSortByValue".
 */
export interface OldTableSortByValue {
  sortBy: SortBy.Value;
  sortOrder: SortOrder;
  sortColumn: SortColumn;
  colSortAttrs: FlatSortConfig[];
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ForecastComparison".
 */
export interface ForecastComparison {
  confidence: number;
  trainingMode: string;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsLegend".
 */
export interface InsightsLegend {
  /**
   * used for flat data, entire selected segments
   */
  individualSelectedSegments?: SavedLegend | null;
  /**
   * used for nested (bar chart) data, filtered segments at each level
   */
  filteredBreakdownSegments?: FilteredBreakdownSegments | null;
  overrides?: LegendOverrides;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SavedLegend".
 */
export interface SavedLegend {
  selected?: SavedLegendItem[] | null;
  expanded?: SavedLegendItem[] | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SavedLegendItem".
 */
export interface SavedLegendItem {
  key?: string | null;
  color?: number | null;
  partial?: boolean | null;
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "LegendOverride".
 */
export interface LegendOverride {
  color: string;
  label?: string | null;
}

/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ChartPlotStyle".
 */
export enum ChartPlotStyle {
  Standard = "standard",
  Stacked = "stacked"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "AnalysisType".
 */
export enum AnalysisType {
  Linear = "linear",
  Logarithmic = "logarithmic",
  Rolling = "rolling",
  Cumulative = "cumulative"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ValueRepresentationType".
 */
export enum ValueRepresentationType {
  Absolute = "absolute",
  Relative = "relative"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "BaseTimeUnit".
 */
export enum BaseTimeUnit {
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ExtendedTimeUnit".
 */
export enum ExtendedTimeUnit {
  Second = "second",
  Minute = "minute",
  Quarter = "quarter",
  Year = "year"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "NonStandardTimeUnit".
 */
export enum NonStandardTimeUnit {
  Session = "session"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SpecialTimeUnit".
 */
export enum SpecialTimeUnit {
  HourOfDay = "hour_of_day",
  DayOfWeek = "day_of_week"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MultiAttributionType".
 */
export enum MultiAttributionType {
  FirstTouch = "first_touch",
  LastTouch = "last_touch",
  Linear = "linear",
  Participation = "participation",
  TimeDecay = "time_decay",
  UShaped = "u_shaped",
  JShaped = "j_shaped",
  InverseJShaped = "inverse_j_shaped",
  Custom = "custom",
  SessionReplayLast = "session_replay_last"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "AxisAssignment".
 */
export enum AxisAssignment {
  Primary = "primary",
  Secondary = "secondary"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "MetricType".
 */
export enum MetricType {
  People = "people",
  Cohort = "cohort",
  Event = "event",
  CustomEvent = "custom-event",
  Funnel = "funnel",
  Retention = "retention",
  RetentionFrequency = "retention-frequency",
  SavedMetric = "saved-metric",
  Formula = "formula",
  Verified = "verified",
  Simple = "simple"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "InsightsResourceType".
 */
export enum InsightsResourceType {
  Events = "events",
  Formulas = "formulas",
  People = "people",
  Cohorts = "cohorts",
  Other = "other",
  All = "all"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelOrder".
 */
export enum FunnelOrder {
  Loose = "loose",
  Any = "any"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ConversionWindowUnit".
 */
export enum ConversionWindowUnit {
  Second = "second",
  Minute = "minute",
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
  Session = "session"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FunnelReentryModeType".
 */
export enum FunnelReentryModeType {
  Default = "default",
  Basic = "basic",
  Aggressive = "aggressive",
  Optimized = "optimized"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FiltersOperator".
 */
export enum FiltersOperator {
  operator_and = "and",
  operator_or = "or",
  or_all = "or_all",
  and_any = "and_any",
  then = "then"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "START_END_TYPE".
 */
export enum START_END_TYPE {
  start = "start",
  end = "end"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RetentionAlignmentType".
 */
export enum RetentionAlignmentType {
  Birth = "birth",
  IntervalStart = "interval_start"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PRIMITIVE_MATH_TYPES".
 */
export enum PRIMITIVE_MATH_TYPES {
  TOTAL = "total",
  UNIQUE = "unique",
  SESSIONS = "sessions",
  AVERAGE = "average",
  MEDIAN = "median",
  P25 = "p25",
  P75 = "p75",
  P90 = "p90",
  P99 = "p99",
  MIN = "min",
  MAX = "max",
  CUMULATIVE_UNIQUE = "cumulative_unique",
  HISTOGRAM = "histogram",
  UNIQUE_VALUES = "unique_values",
  MOST_FREQUENT = "most_frequent",
  FIRST_VALUE = "first_value",
  MULTI_ATTRIBUTION = "multi_attribution",
  NUMERIC_SUMMARY = "numeric_summary"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "NUMERIC_MATH_TYPES".
 */
export enum NUMERIC_MATH_TYPES {
  P25 = "p25",
  P75 = "p75",
  P90 = "p90",
  P99 = "p99"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "XAU_MATH_TYPES".
 */
export enum XAU_MATH_TYPES {
  DAU = "dau",
  WAU = "wau",
  MAU = "mau"
}
/**
 * only a subset of operations are valid for per user aggregations, keep this enum separate
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "PER_USER_AGGREGATIONS".
 */
export enum PER_USER_AGGREGATIONS {
  TOTAL = "total",
  AVERAGE = "average",
  MIN = "min",
  MAX = "max",
  UNIQUE_VALUES = "unique_values",
  SESSION_REPLAY_ID_VALUE = "session_replay_id_value"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "FUNNELS_MATH_TYPES".
 */
export enum FUNNELS_MATH_TYPES {
  GENERAL = "general",
  UNIQUE = "unique",
  SESSION = "session",
  CONVERSION_RATE = "conversion_rate",
  CONVERSION_RATE_UNIQUE = "conversion_rate_unique",
  CONVERSION_RATE_TOTAL = "conversion_rate_total",
  CONVERSION_RATE_SESSION = "conversion_rate_session",
  PROPERTY_SUM = "total"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "RETENTION_MATH_TYPES".
 */
export enum RETENTION_MATH_TYPES {
  UNIQUE = "unique",
  RETENTION_RATE = "retention_rate",
  PROPERTY_SUM = "total",
  PROPERTY_AVERAGE = "average"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "COUNT_USERS_ONCE_TYPE".
 */
export enum COUNT_USERS_ONCE_TYPE {
  MULTIPLE = "all",
  FIRST = "first",
  LAST = "last"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortOrder".
 */
export enum SortOrder {
  Ascending = "asc",
  Descending = "desc"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortColumn".
 */
export enum SortColumn {
  Linear = "Linear",
  Sum = "sum",
  Value = "value"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "ChartType".
 */
export enum ChartType {
  Bar = "bar",
  Line = "line",
  Pie = "pie",
  StackedBar = "bar-stacked",
  StackedLine = "stacked-line",
  Table = "table",
  Metric = "insights-metric",
  Column = "column",
  StackedColumn = "stacked-column",
  LegacyMetric = "metric",
  Sankey = "sankey",
  Flows = "flows",
  FlowsTopPaths = "paths",
  FunnelTopPaths = "funnel-top-paths",
  FunnelSteps = "funnel-steps",
  FunnelStepsMetric = "funnel-steps-metric",
  FunnelTrend = "funnel-trend",
  FunnelFrequencyLine = "funnel-frequency-line",
  FunnelFrequencyBar = "funnel-frequency-bar",
  FunnelTTCLine = "funnel-ttc-line",
  FunnelTTCBar = "funnel-ttc-bar",
  FunnelMedianTTC = "funnel-median-ttc",
  RetentionLine = "line-retention",
  RetentionTrend = "retention-trend",
  RetentionTrendMetric = "retention-trend-metric",
  RetentionTable = "retention-table",
  RetentionCurve = "retention-curve",
  Frequency = "frequency",
  ImpactAdoption = "impact-adoption",
  ImpactTrends = "impact-trends",
  ImpactPropensity = "impact-propensity"
}
/**
 * This exists at the top of a metric / show clause.
 *
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "TopLevelMetricType".
 */
export enum TopLevelMetricType {
  Metric = "metric",
  Formula = "formula",
  MetricEntry = "metric-entry",
  NewMetricEntry = "new-metric-entry",
  NewFormulaEntry = "new-formula-entry"
}
/**
 * This interface was referenced by `InsightsBookmarkParams`'s JSON-Schema
 * via the `definition` "SortBy".
 */
export enum SortBy {
  Value = "value",
  Label = "label",
  Column = "column",
  LiftComparisonValue = "liftComparisonValue"
}
